import React, { useMemo } from 'react'

export type SwitchType = {
  onChange?: (name: string, value:any) => void,
  value?: any,
  name?: string,
  form?: Record<string, any>,
  info?: string,
  readOnly ?: boolean
}

const Switch = (props: SwitchType) => {
  const {
    onChange,
    value,
    name,
    form,
    info,
    readOnly
  } = props

  const onSwitch = (e) => {
    if (onChange) {
      onChange(name, e?.target?.checked)
    }
  }

  const checked = useMemo(() => {
    const val = value || (form && form[name]) || false
    if (typeof val === 'string') {
      return val === 'true'
    }

    return val
  }, [value, form[name]])

  return (
    <div className="d-flex row align-center">
      <div className={`tennders-ios-switch${info ? ' mr-16' : ''}`}>
        <input onChange={onSwitch} type="checkbox" readOnly={readOnly} disabled={readOnly} id={name} checked={checked} />
        <label htmlFor={name}></label>
      </div>
      {info && <span className="font-italic flex-1">{info}</span>}
    </div>
  )
}

export default Switch
